import { DateTimePicker } from "@mui/x-date-pickers";
import BaseCadastro from "components/BaseCadastro";
import { useToastContext } from "components/alert/ToastContext";
import { Label } from "components/input/Label";
import dayjs from "dayjs";
import Feriado from "model/administracao/cadastro/Feriado";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { confirmDialog } from "primereact/confirmdialog";
import { InputText } from "primereact/inputtext";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import FeriadoAdmService from "service/administracao/cadastro/FeriadoAdmService";

const feriadoService = new FeriadoAdmService();

export default function FeriadoAdmCadastro() {

    const { msgSucesso, msgErro } = useToastContext();

    const { setError, formState: { errors }, register, clearErrors, control } = useForm();

    const [feriado, setFeriado] = useState<Feriado>(new Feriado());

    useEffect(() => {
    }, []);

    function validar() {

        if (!feriado.nome) {
            setError("nome", { type: "manual", message: "Nome é obrigatório" }, { shouldFocus: true })
            return false;
        }

        if (!feriado.data) {
            setError("data", { type: "manual", message: "Data é obrigatória" }, { shouldFocus: true })
            return false;
        }

        return true;
    }

    function aplicarFeriadoTodasContas() {

        confirmDialog({
            acceptLabel: 'Sim',
            rejectLabel: 'Não',
            message: 'Deseja realmente aplicar este feriado em todas as contas?',
            header: 'Confirmação',
            icon: 'pi pi-exclamation-triangle',
            accept: () => aplicarFeriadoTodasContasConfirmacao(),
        });

    }

    function aplicarFeriadoTodasContasConfirmacao() {

        feriadoService.aplicarTodasContas(feriado.id).then(() => {
            msgSucesso('Sucesso', 'Feriado aplicado em todas as contas com sucesso');
        }).catch(err => {
            console.log(err);
            msgErro('Erro', 'Erro ao aplicar o feriado em todas as contas');
        });
    }

    function botoesExtra() {

        if (feriado.id) {
            return <>
                <Button type="button" label="Aplicar em todas as contas" className="ui-button-info" style={{ marginLeft: 8 }} onClick={() => {
                    aplicarFeriadoTodasContas();
                }}></Button>
            </>
        }

        return null;
    }

    return (

        <BaseCadastro model={feriado} service={feriadoService} setModel={(value: Feriado) => {
            setFeriado(value);
        }}
            botoesExtra={botoesExtra()}
            validar={() => validar()} urlService="/feriadoadm" pathCadastro="/feriadoadm" tituloPagina={'Feriados - Administração'}>

            <div style={{ display: "flex" }}>
                <Checkbox
                    checked={feriado.replicaAnualmente}
                    onChange={(e) => { setFeriado({ ...feriado, replicaAnualmente: e.checked as boolean }) }}
                    style={{ marginRight: 5 }}
                />
                <label>Replicar anualmente?</label>
            </div>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Nome</Label>
                <div className="col-sm-12">
                    <InputText required value={feriado.nome} style={{ width: '100%' }}
                        className={errors.nome ? "p-invalid" : ""}
                        {...register("nome", {
                            onChange: (e) => {
                                clearErrors("nome");
                                setFeriado({ ...feriado, nome: e.target.value })
                            }
                        })}
                    />
                </div>
                {errors.nome && errors.nome.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.nome?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Data</Label>
                <div className="col-sm-12">

                    <Controller name="data" control={control} render={({ field }) => (
                        <DateTimePicker
                            inputRef={field.ref}
                            value={dayjs(feriado.data)}
                            ampm={false}
                            className="data-feriado"
                            views={feriado.replicaAnualmente ? ['day', 'month'] : ['day', 'month', 'year']}
                            format={feriado.replicaAnualmente ? "DD/MM" : "DD/MM/YYYY"}
                            onChange={value => {
                                clearErrors("data")
                                setFeriado({ ...feriado, data: value?.toDate() || null })
                            }}
                        />
                    )} />

                </div>
                {errors.data && errors.data.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.data?.message as string}</span> : null}
            </div>

        </BaseCadastro>
    )
}
